import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedLayout } from "@/components/app/ProtectedLayout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Feed from "@/pages/Feed";
import OpponentMoney from "@/pages/OpponentMoney";
import LocalPress from "@/pages/LocalPress";
import ContentStudio from "@/pages/ContentStudio";
import AgentConsole from "@/pages/AgentConsole";
import Briefings from "@/pages/Briefings";
import VoterFile from "@/pages/VoterFile";
import Personas from "@/pages/Personas";
import Segments from "@/pages/Segments";
import SentimentMap from "@/pages/SentimentMap";
import GOTV from "@/pages/GOTV";
import Contacts from "@/pages/Contacts";
import Outreach from "@/pages/Outreach";
import Canvassing from "@/pages/Canvassing";
import Automations from "@/pages/Automations";
import SettingsPage from "@/pages/Settings";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/money" element={<OpponentMoney />} />
            <Route path="/press" element={<LocalPress />} />
            <Route path="/studio" element={<ContentStudio />} />
            <Route path="/agent" element={<AgentConsole />} />
            <Route path="/briefings" element={<Briefings />} />
            <Route path="/voters" element={<VoterFile />} />
            <Route path="/personas" element={<Personas />} />
            <Route path="/segments" element={<Segments />} />
            <Route path="/map" element={<SentimentMap />} />
            <Route path="/gotv" element={<GOTV />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/outreach" element={<Outreach />} />
            <Route path="/canvassing" element={<Canvassing />} />
            <Route path="/automations" element={<Automations />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
